import React from "react";
import { Modal, Button } from "react-bootstrap";

const LogoutConfirmationModal = ({ show, onConfirm, onCancel }) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "#ff4f00" }}>Confirm Logout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-dark">Are you sure you want to log out?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          className="btn btn-secondary bg-secondary text-white"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          style={{ backgroundColor: "#ff4f00" }}
          className="btn btn-danger bg-danger text-white"
          onClick={onConfirm}
        >
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutConfirmationModal;
